function showSecondarySection(sectionId, currentTab, mobileOffsetValue=0, desktopOffsetValue = 0) {
  let section = document.getElementById(sectionId);
  let isSmallScreen = window.matchMedia('(max-width: 749px)').matches;
  let mainNavbarMargin = 0;
  
  const mainNoOfTabs = document.querySelectorAll('.custom-tab');
  if (mobileOffsetValue == 0) {
    mainNavbarMargin = mainNoOfTabs.length > 3 ? 45 : 15;
  } else {
    mainNavbarMargin = mainNoOfTabs.length > 3 ? 27 + mobileOffsetValue : mobileOffsetValue;
  }

  let marginMainNavbarSection = isSmallScreen ? mainNavbarMargin : 40;
  let marginSecondaryNavbarSection = isSmallScreen ? 50 : 40 + desktopOffsetValue;
  let marginHeader = isSmallScreen ? 52 : 60;
    
  let rect = section.getBoundingClientRect();
  let scrollPosition = rect.top + window.scrollY;
  if (scrollPosition > window.scrollY) {
    // Scrolling down (section is below current location)
    window.scrollTo({top: scrollPosition - marginMainNavbarSection - marginSecondaryNavbarSection, behavior: 'smooth'});
  } else {
    // Scrolling up (section is above current location)
    window.scrollTo({top: scrollPosition - marginMainNavbarSection - marginSecondaryNavbarSection - marginHeader, behavior: 'smooth'});
  }    

  document.querySelectorAll('.custom-secondary-tab').forEach(function(tab) {
    tab.classList.remove('custom-current');
  });
  currentTab.classList.add('custom-current');
}